export default __webpack_public_path__ + "static/media/Adjunta_credencial_reverso.ecbb6564.gif";